import React, {useEffect} from 'react'
import paths from '../../routes/paths'
import {CircularProgress} from '@mui/material'
import surveysApi from '../../services/api/surveys/surveysApi'
import PupilDashboard from './PupilDashboard'
import WbLoader from '../../components/common/WbLoader'
import usePupilData from '../../hooks/usePupilData'

export default function PupilSurveys() {
  const [loading, setLoading] = React.useState(true)
  //const [pupil, setPupil] = React.useState(null)
  const [surveys, setSurveys] = React.useState([])
  const pupil = usePupilData()

  useEffect(() => {
    if (!pupil) {
      window.location.href = paths.pupilDashLogin
    }
    surveysApi
      .getPupilSurveys(
        pupil.schoolId, // pupil.groupId,
        pupil.studentId
      )
      .then(res => {
        if (res.length === 1) {
          window.location.href = res[0].url
        }
        setSurveys(res)
        setLoading(false)
      })
  }, [])

  return loading ? <WbLoader /> : <PupilDashboard surveys={surveys} />
}
